import { CodeBook } from "@king-ict/eupisi-ui/models";
import { codeBookToSelectData } from "@king-ict/eupisi-ui/utils";
import { TFunction } from "i18next";

import { MzomAppealStatusEnum } from "../../../models/Request/MzomAppeal";

export const getMzomAppealStatusSelectData = (t: TFunction) =>
  codeBookToSelectData([
    {
      id: MzomAppealStatusEnum.Accepted,
      name: t("mzomAppeal.status.accepted"),
    },
    {
      id: MzomAppealStatusEnum.Rejected,
      name: t("mzomAppeal.status.rejected"),
    },
  ]);

export const getMzomAppealTypeName = (
  typeId: number | undefined,
  typeList?: CodeBook[]
) => {
  if (!typeId) {
    return undefined;
  }

  return typeList?.find((item) => item.id === typeId)?.name;
};

export const getMzomAppealStatusName = (
  status: MzomAppealStatusEnum | undefined,
  t: TFunction
) => {
  if (!status) {
    return undefined;
  }

  return getMzomAppealStatusSelectData(t).data.find((item) => item.id === status)
    ?.name;
};

export const getMzomAppealOutcomeName = (
  outcomeId: number | undefined,
  outcomeList?: CodeBook[]
) => {
  if (!outcomeId) {
    return undefined;
  }

  return outcomeList?.find((item) => item.id === outcomeId)?.name;
};
